import { AUTOPILOT_CLIENT_ID } from 'helpers/donate';

// Client IDs eligible for express checkout recommendations: Oath (100) and Autopilot (182)
export const OATH_CLIENT_ID = 100;
export const CAROUSEL_CLIENT_IDS = [OATH_CLIENT_ID, AUTOPILOT_CLIENT_ID];
export const MAX_CARD_COUNT = 3;
export const AUTOPILOT_QUERY_STRINGS = ['auto-pd', 'auto-fh'];
